/* eslint-env es6 */
// Stub for @okta/ui-libraries-oidc-auth-headers (not used by the sign-in widget)
export const AuthorizationHeaderTypes = {};
export const getOAuth2HeadersProvider = () => ({
  getOAuth2Headers: () => ({}) // no-op
});
